var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"no-underline mx-2",attrs:{"href":_vm.url,"data-size":"large","target":"_blank"}},[_c('span',{staticClass:"icon icon-document"})])}
var staticRenderFns = []

export { render, staticRenderFns }